"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterLocalDateTimeCell = exports.FilterInstantDateTimeCell = exports.DisabledFilterDateTimeCell = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const instant_field_1 = require("../../instant-field/instant-field");
const select_1 = require("../../select/select");
const field_filter_api_1 = require("../field-filter-api");
const field_filter_hook_1 = require("../field-filter-hook");
const field_filter_styles_1 = require("../field-filter-styles");
function DisabledFilterDateTimeCell(props) {
    return react_1.default.createElement(FilterDateTimeCell, { ...props, disabled: true });
}
exports.DisabledFilterDateTimeCell = DisabledFilterDateTimeCell;
const FilterInstantDateTimeCell = (props) => (react_1.default.createElement(FilterDateTimeCell, { ...props, representation: "instant" }));
exports.FilterInstantDateTimeCell = FilterInstantDateTimeCell;
const FilterLocalDateTimeCell = (props) => (react_1.default.createElement(FilterDateTimeCell, { ...props, representation: "local-date-time" }));
exports.FilterLocalDateTimeCell = FilterLocalDateTimeCell;
function FilterDateTimeCell({ disabled, value, onChange, state, onChangeState, representation, }) {
    const classes = (0, field_filter_styles_1.useFilterStyles)();
    const operations = (0, field_filter_api_1.useCompareOperations)();
    const { handleChangeOperation } = (0, field_filter_hook_1.useFilterOperation)(state, onChangeState);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.root, { [classes.disabled]: disabled }) },
        react_1.default.createElement("div", { className: classes.selectWrapper },
            react_1.default.createElement(select_1.Select, { source: operations, value: state.operation, onChange: handleChangeOperation, valueIsId: true, clearable: false, disabled: disabled })),
        react_1.default.createElement("div", { className: classes.textWrapper },
            react_1.default.createElement(instant_field_1.InstantField, { representation: representation, value: value, onChange: onChange, disabled: disabled }))));
}
//# sourceMappingURL=filter-date-time-cell.js.map